var cov_28fd87fx47 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/styles/index.js",
      hash = "21ce8954c9a3a6279847b234db0aaf594386529f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var menuLess = {};
import genaration from '../../utils/classname';
export var menuClass = (cov_28fd87fx47.s[0]++, genaration(menuLess, 'menu'));